import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from '@core/interceptors';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { TimeagoModule } from 'ngx-timeago';

import { provideMapboxGL } from 'ngx-mapbox-gl';

import { environment } from '@env/environment';
import { Observable } from 'rxjs';
const { apiUrl } = environment;

// Loader personalizado para evitar problemas de codificación
export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    // Construimos la URL manualmente para evitar codificación de caracteres
    const url = `${apiUrl}web-labels/language/${lang}`;
    return this.http.get(url);
  }
}

export function createTranslateLoader(http: HttpClient): CustomTranslateLoader {
  return new CustomTranslateLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([httpInterceptor])),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    provideMapboxGL({
      accessToken: environment.mapboxKey,
    }),
    importProvidersFrom([
      TranslateModule.forRoot({
        fallbackLang: 'es',
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
        isolate: true,
      }),
      TimeagoModule.forRoot(),
    ]),
  ],
};
